import { DOCUMENT } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CookieService, GlobalAlertService } from '@service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private globalAlertService: GlobalAlertService,
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let lastResponse;
    let error;

    return next.handle(request).pipe(
      map(event => {
        lastResponse = event;
        return event;
      }),
      catchError((err: unknown) => {
        error = err;
        if (!(err instanceof HttpErrorResponse)) {
          return throwError(() => new Error(err.toString()));
        }
        const errorLogic = (): string => {
          this.cookieService.deleteCookie('des_session');
          const errorMessage = `${err.error?.statusCode ?? err.status}: ${err.error?.message ?? err.name} - ${err.error?.name ?? err.error?.Message}`;
          this.globalAlertService.setError(errorMessage, 10000);
          return errorMessage;
        };
        let errorMessage: string;
        switch (err.status) {
          case 401:
            errorMessage = errorLogic();
            console.error(`Must have an expired or invalid session.  Clearing cookies, rerouting to login.`, err);
            void this.router.navigate(['/']);
            break;
          case 403:
            errorMessage = errorLogic();
            this.document.defaultView.location.reload();
            break;
        }
        return throwError(() => new Error(errorMessage ?? err.toString()));
      }),
      finalize(() => {
        if (lastResponse.type === HttpEventType.Sent && !error) {
          // last response type was 0, and we haven't received an error
        }
      }),
    );
  }
}
